import { useState, useCallback, useRef, useEffect } from "react";
import Axios from "axios";
import { environment } from "../../environment";
import { errorCatcher } from "../../hooks";
import { useLogin } from "../login";
import { IAnalyzeRequest, IDiagnosticResult } from "./types";

const analyzeUrl = `${environment.v2Url}/design/diagnostics/analyze`;

export const useDiagnostics = () => {
    const [loading, setLoading] = useState(false);
    const [, authToken, loginFunctions] = useLogin();
    const loginFunctionsRef = useRef(loginFunctions);

    useEffect(() => {
        loginFunctionsRef.current = loginFunctions;
    }, [loginFunctions]);

    const analyze = useCallback(async (input: IAnalyzeRequest): Promise<IDiagnosticResult | null> => {
        setLoading(true);
        // A file → multipart upload (stored server-side); otherwise a JSON image_url.
        let result;
        if (input.file) {
            const fd = new FormData();
            fd.append('image', input.file);
            if (input.name) fd.append('name', input.name);
            result = await Axios.post(analyzeUrl, fd, {
                headers: { 'X-Wallmates-Auth': authToken }
            }).catch((err: any) => errorCatcher(err, loginFunctionsRef.current.logout));
        } else {
            result = await Axios.post(analyzeUrl, { image_url: input.image_url, name: input.name }, {
                headers: { 'X-Wallmates-Auth': authToken }
            }).catch((err: any) => errorCatcher(err, loginFunctionsRef.current.logout));
        }
        setLoading(false);
        return result ? (result.data as IDiagnosticResult) : null;
    }, [authToken]);

    return { loading, analyze };
};
